import config from '../../config';

export default function PresenceApi({ makeRequest, buildRequest }) {
	function viewEnquiryPresence(enquiryId, connectionId) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${enquiryId}/presence`, { connectionId }, { suppressErrorToast: true }))
		);
	}

	function leaveEnquiryPresence(enquiryId, connectionId) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enquiry/${enquiryId}/presence/leave`, { connectionId }, { suppressErrorToast: true }))
		);
	}

	function subscribeEnquiryPresence(connectionId) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Enquiry/presence/subscribe', { connectionId }, { suppressErrorToast: true }))
		);
	}

	// Synchronous keepalive request so it survives pagehide; interceptors are async so bypass axios.
	function leaveEnquiryPresenceKeepalive(enquiryId, connectionId, csrfToken) {
		return fetch(`${config.pathwayApiUrl}/api/Enquiry/${enquiryId}/presence/leave`, {
			method: 'POST',
			keepalive: true,
			credentials: 'include',
			headers: {
				'content-type': 'application/json',
				...(csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {}),
			},
			body: JSON.stringify({ connectionId }),
		}).catch(() => undefined);
	}

	function getEnquiryPresence(enquiryIds) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enquiry/presence', {
				params: { ids: enquiryIds.join(',') },
				suppressErrorToast: true,
			}))
		);
	}

	return {
		viewEnquiryPresence,
		leaveEnquiryPresence,
		subscribeEnquiryPresence,
		leaveEnquiryPresenceKeepalive,
		getEnquiryPresence,
	};
}
